import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { Helmet } from "react-helmet";

function Technology() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const data = await fetchNewsByCategory("technology");
      setNews(data);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>
          Breaking Technology News | AI, Gadgets & Mobile Updates – BharatAbroad
        </title>
        <meta
          name="title"
          content="Breaking Technology News | AI, Gadgets & Mobile Updates – BharatAbroad"
        />
        <meta
          name="description"
          content="Discover breaking technology news with updates on smartphones, AI, apps, startups, cybersecurity, gadgets, and emerging tech trends on BharatAbroad."
        />
        <meta
          name="keywords"
          content="global technology news, world tech updates, international gadget news, latest smartphone launches worldwide, AI news global, artificial intelligence trends worldwide, machine learning updates global, cloud computing worldwide, cybersecurity news global, tech startups worldwide, startup funding global, fintech news global, SaaS companies worldwide, IT industry global, digital payments worldwide, social media trends global, ecommerce news worldwide, online business global, digital marketing worldwide, latest gadget reviews global, technology trends 2026 worldwide, cybersecurity updates global today, AI tools worldwide, ChatGPT global news, software updates worldwide, tech apps global, internet users worldwide, new smartphone launch global 2026, best budget smartphones worldwide 2026, AI technology updates global, technology industry breaking news, digital innovation worldwide, emerging tech trends global, future technology 2026, global IT companies, unicorn startups worldwide, technology news India, latest tech news, tech news today, gadgets news India, smartphone news, technology updates, digital India news, IT news India, tech industry news, latest technology news today, trending tech news India, AI news today, new smartphone launch today, tech updates today India, latest gadget news India, breaking tech news, new technology trends 2026, smartphone price India, mobile launch India, best smartphones 2026, phone review India, Android updates India, iPhone news India, mobile specs and features, budget smartphones India, artificial intelligence news, AI tools India, ChatGPT news, machine learning India, software updates, tech apps India, cloud computing India, cybersecurity news, tech startups India, startup funding news India, Indian tech companies, unicorn startups India, startup news today, fintech news India, SaaS companies India, IT companies news, digital payments India, UPI news India, online services India, internet users India, social media trends India, ecommerce India news, online business India, digital marketing India, latest tech news India today, new smartphone launch in India 2026, AI technology updates India, best budget smartphones India 2026, tech startup news India today, latest gadget reviews India, technology trends in India 2026, cybersecurity updates India today, BharatAbroad technology, BharatAbroad tech news, BharatAbroad gadgets, BharatAbroad AI news, BharatAbroad startup news"
        />

        {/* Technical */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Technology News | Gadgets, Smartphones, AI & Startups – BharatAbroad"
        />
        <meta
          property="og:description"
          content="Stay updated with the latest technology news, smartphone launches, gadget reviews, AI tools, IT industry updates, cybersecurity trends, and startup funding stories on BharatAbroad."
        />
        <meta property="og:site_name" content="BharatAbroad" />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/technology"
        />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-technologys.webp"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Technology News | Gadgets, Smartphones, AI & Startups – BharatAbroad"
        />
        <meta
          name="twitter:description"
          content="Get the latest technology news, smartphone launches, gadget reviews, AI tools, IT industry updates, cybersecurity trends, and startup funding stories on BharatAbroad."
        />
        <meta
          name="twitter:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-technologys.webp"
        />
        <meta name="twitter:site" content="@BharatAbroad" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.bharatabroad.com/technology" />
      </Helmet>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          <NewsSection
            title="Technology News"
            articles={news}
            category="technology"
          />
        </div>
      </div>
    </>
  );
}

export default Technology;
